import { render, staticRenderFns } from "./ServiceDashboard.vue?vue&type=template&id=a68bb52c&scoped=true&"
import script from "./ServiceDashboard.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDashboard.vue?vue&type=style&index=0&id=a68bb52c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68bb52c",
  null
  
)

export default component.exports